function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-0.000244141 2C-0.000244141 0.89543 0.895186 0 1.99976 0H21.9998C23.1043 0 23.9998 0.895431 23.9998 2V22C23.9998 23.1046 23.1043 24 21.9998 24H1.99976C0.895186 24 -0.000244141 23.1046 -0.000244141 22V2Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 1L18 7C18 8.65685 16.6569 10 15 10L9 10C7.34315 10 6 8.65685 6 7L6 0.999999",
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 23L6 17C6 15.3431 7.34315 14 9 14L15 14C16.6569 14 18 15.3431 18 17L18 23",
  stroke: "black"
});

function SvgDirectionColumn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionColumn);
export default __webpack_public_path__ + "static/media/direction-column.8d6dfd0a.svg";
export { ForwardRef as ReactComponent };